import React from "react";
import { Link, useParams } from "react-router-dom";
import { newsItems } from "./posts";
import '../../styles/news/eventsDetails.css';

export default function EventsDetailPage() {
	const { slug } = useParams();
	const post = newsItems.find((p) => p.slug === slug);

	if (!post) {
		return (
			<main className="detailPage">
				<div className="detailContainer">
					<div className="detailNotFound">
						<h1>Not found</h1>
						<p>This event doesn't exist.</p>
						<Link to="/events">← Back to Events</Link>
					</div>
				</div>
			</main>
		);
	}

	const c = post.content || {};

	return (
		<main className="detailPage">
			<img className="details-page-banner" src={post.heroImageUrl} alt="" />

			<div className="detailContainer">
				<article className="detailCard">
					<h1 className="detailTitle">{post.title}</h1>

					{post.event && (
						<ul className="detailFacts">
							<li><span className="factIcon" aria-hidden="true">📅</span><span>{post.event.dateLabel}</span></li>
							<li><span className="factIcon" aria-hidden="true">⏰</span><span>{post.event.timeLabel}</span></li>
							<li><span className="factIcon" aria-hidden="true">📍</span><span>{post.event.locationLabel}</span></li>
						</ul>
					)}

					{c.paragraphs?.map((para, i) => (
						<p className="detailP" key={`p-${i}`}>{para}</p>
					))}

					{c.bullets?.length > 0 && (
						<>
							{ c.bulletsTitle && <p className="detailP strong">{c.bulletsTitle}</p> }
							<ul className="detailBullets">
								{c.bullets.map((b, i) => <li key={`b-${i}`}>{b}</li>)}
							</ul>
						</>
					)}

					{c.paragraphsAfter?.map((para, i) => (
						<p className="detailP" key={`pa-${i}`}>{para}</p>
					))}

					{c.sections?.map((s, i) => (
						<section key={`s-${i}`} className="detailSection">
							<h2 className="detailH2">{s.heading}</h2>
							{s.paragraphs?.map((para, j) => (
								<p className="detailP" key={`sp-${i}-${j}`}>{para}</p>
							))}
							{s.bullets?.length > 0 && (
								<ul className="detailBullets">
									{s.bullets.map((b, j) => <li key={`sb-${i}-${j}`}>{b}</li>)}
								</ul>
							)}
						</section>
					))}

					{c.links?.length > 0 && (
						<div className="detailLinks">
							{c.links.map((l, i) => (
								<p className="detailP" key={`l-${i}`}>
									<a className="detailLink" href={l.href} target="_blank" rel="noreferrer">
										{l.label}
									</a>
								</p>
							))}
						</div>
					)}

					<div className="detailBack">
						<Link to="/events">← Back to Events</Link>
					</div>
				</article>
			</div>
		</main>
  	);
}